export default __webpack_public_path__ + "static/discover-the-aurora-borealis-on-your-next-holiday-edc5bd6f5552828ab87dcdb1ddb6dce8.jpg";